import { render } from "./AdminCityDetail.vue?vue&type=template&id=15f7f660&scoped=true&ts=true&lang=true"
import script from "./AdminCityDetail.vue?vue&type=script&lang=ts"
export * from "./AdminCityDetail.vue?vue&type=script&lang=ts"

import "./AdminCityDetail.vue?vue&type=style&index=0&id=15f7f660&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f7f660"]])

export default __exports__